//接口地址
  //let commonUrl = "//tzi.au666.top/";
  let commonUrl = "//xx.bcacm.xyz/";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl